import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

// ==============================|| PROTECTED ROUTE COMPONENT ||============================== //

const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem('admin_accesstoken');
  const userInfo = useSelector((state) => state.auth?.userInfo);

  if (!token || !userInfo?.role) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userInfo.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
